import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { zIndex } from "../config/zIndex";

const Wrapper = styled.div`
	height: ${(props) => props.heightVal};
	width: ${(props) => props.widthVal};
	background-color: ${(props) => props.bgColor};
	position: relative;
	margin: ${(props) => props.margin};
	border: ${(props) => props.border};
	border-radius: 4px;
	box-shadow: ${(props) => props.boxShadow};
`;

const Header = styled.div`
	display: flex;
	height: 100%;
	padding: 0.3rem 0.8rem;
	font-size: ${(props) => props.headerFontSize};
	justify-content: space-between;
	align-items: center;
`;

const List = styled.div`
	overflow-y: auto;
	width: 100%;
	position: absolute;
	margin: ${(props) => props.margin};
	bottom: ${(props) => props.bottomVal};
	padding: 0;
	background: #fff;
	height:max-content;
	max-height: ${(props) => props.maxHeight};
	border: 2px solid #e5e5e5;
	z-index: ${zIndex.dropdown};
	opacity: ${(props) => props.opacity};
	pointer-events: ${(props) => props.pointerEvents};
`;
const ListItem = styled.div`
	width:100%;
	display: flex;
	pointer-events: ${(props) => props.pointerEvents};
	background: #fff;
	align-items: none;
	justify-content: none;
	padding: 0.5rem;
	list-style: none;
	border-top: 1px solid #e5e5e5;
	z-index: ${zIndex.stickyHeader};
	overflow:hidden;
	&:hover {
		background: #faebd7;
	}
`;

const Div = styled.div`
	display: flex;
	height: ${(props) => props.height};
	flex-direction: ${(props) => props.flexD};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	margin: ${(props) => props.margin};
`;

Wrapper.defaultProps = {
	margin: "0 auto",
	border: "none",
	widthVal: "100%",
	bgColor: "#fff",
	boxShadow: "rgba(45, 35, 66, 0.2) 0 2px 4px,rgba(45, 35, 66, 0.15) 0 7px 13px -3px,#D6D6E7 0 -3px 0 inset",
};

Header.defaultProps = {
	headerFontSize: "1.2rem",
};

List.defaultProps = {
	pointerEvents: "none",
	margin: "0",
	maxHeight:"8rem"
};

ListItem.defaultProps = {
	pointerEvents: "none",
};

const Dropdown = (props) => {
	const { head, value, optionsList, onChange, inverted, ErrorName } = props;
	const [open, IsOpen] = useState(false);
	const [selectedOpt, setSelectedOpt] = useState(value);

	const menuRef = useRef();

	function handleChange(value) {
		onChange && onChange(value);
		IsOpen(!open);
	}

	useEffect(() => {
		document.addEventListener("mousedown", handleClick);

		return () => {
			document.removeEventListener("mousedown", handleClick);
		};
	}, []);

	function handleClick(event) {
		if (!menuRef.current.contains(event.target)) {
			IsOpen(false);
		}
	}

	function displayValue(list) {
		//Added a check to allow values to be zero
		if (typeof selectedOpt !== 'undefined') {
			let displayVal;

			list &&
				list.map((item) => {
					if (item.value === selectedOpt) {
						displayVal = item.head;
					}
				});

			if(displayVal) return displayVal;
		} 
		return head;
	}

	return (
		<Wrapper
			height={props.heightVal}
			onClick={() => props.Focus && props.name && props.Focus(props.name)}
			ref={menuRef}
			borderVal={
				props.name && ErrorName && ErrorName.includes(props.name)
					? "1px solid red"
					: props.borderVal
			}
			{...props}>
			<Header {...props} onClick={() => IsOpen(!open)}>
				<Div height="100%" alignItem="center" >
					<Span fontSize="16px" >{displayValue(optionsList, selectedOpt)}</Span>
				</Div>
				<Div margin="0.2rem 0 0 0.5rem">
					<span
						style={{ transition: "0.2s all ease-in-out", fontSize: "1.3rem", cursor: "pointer" }}
						className={
							open
								? "material-symbols-outlined rotate-up"
								: "material-symbols-outlined"
						}>
						keyboard_arrow_down
					</span>
				</Div>
			</Header>
			{!props.inverted && (
				<List
					maxHeight={props.maxHeight}
					className={open ? "dropdown-open" : "dropdown-close"}
					pointerEvents={open ? "all" : "none"}>
					{optionsList &&
						optionsList.map((option) => (
							<ListItem
								key={option.value}
								pointerEvents={open ? "all" : "none"}
								onClick={() => {
									setSelectedOpt(option.value);
									handleChange(option.value);
								}}>
								{option.head}
								{/*option.subhead!== '' &&  <span fontSize="0.8rem" colorVal="#7b8996">{option.subhead}</span>*/}
							</ListItem>
						))}
				</List>
			)}
		</Wrapper>
	);
};

export default Dropdown;
